import { render, staticRenderFns } from "./PracticeTest.vue?vue&type=template&id=5eb6f746&scoped=true&"
import script from "./PracticeTest.vue?vue&type=script&lang=js&"
export * from "./PracticeTest.vue?vue&type=script&lang=js&"
import style0 from "./PracticeTest.vue?vue&type=style&index=0&id=5eb6f746&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb6f746",
  null
  
)

export default component.exports